const Gallery = () => {
  const galleryImages = [
    { url: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?w=500', alt: 'Hårstyling 1' },
    { url: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=500', alt: 'Hårfärgning 1' },
    { url: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=500', alt: 'Salongens interiör' },
    { url: 'https://images.unsplash.com/photo-1492106087820-71f1a00d2b11?w=500', alt: 'Hårstyling 2' },
    { url: 'https://images.unsplash.com/photo-1595475884562-073c30d45670?w=500', alt: 'Hårbehandling' },
  ];

  return (
    <section id="gallery" className="section section-alt">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <p className="text-heading mb-3 sm:mb-4 text-sm sm:text-base">Galleri</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-4 sm:mb-6">Transformationer</h2>
          <div className="divider" />
          <p className="text-sm sm:text-base text-[var(--color-text-secondary)] mt-4 sm:mt-6 max-w-2xl mx-auto px-4">
            Se inspirerande före- och efterbilder från våra behandlingar.
            Följ oss på Instagram för dagliga uppdateringar!
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 md:gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="aspect-square overflow-hidden rounded-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

        {/* Instagram Link */}
        <div className="text-center mt-10 sm:mt-12 md:mt-16">
          <p className="text-sm sm:text-base text-[var(--color-text-secondary)] mb-4 sm:mb-6 px-4">
            Följ oss på Instagram för mer inspiration och dagliga uppdateringar
          </p>
          <a
            href="https://www.instagram.com/hargalleriet_selma_p"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-heading hover:text-[var(--color-accent-500)] transition-colors"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            @hargalleriet_selma_p
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
